import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import aboutimg from "../assets/img/about poster.png";
import icon1 from "../assets/img/icon-03-primary.png";
import icon2 from "../assets/img/icon-04-primary.png";
import ceo from "../assets/img/ceo img.png";

function SecondaryAbout() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-5">
          <div
            className="col-lg-6"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <div
              className="position-relative overflow-hidden rounded ps-5 pt-5 h-100"
              style={{ minHeight: "400px" }}
            >
              <img
                className="position-absolute w-100 h-100"
                src={aboutimg}
                alt="Career Guidance"
                style={{ objectFit: "cover" }}
              />
              <div
                className="position-absolute top-0 start-0 bg-white rounded pe-3 pb-3"
                style={{ width: "200px", height: "200px" }}
              >
                <div className="d-flex flex-column justify-content-center text-center bg-primary rounded h-100 p-3">
                  <h1 className="text-white mb-0">10+</h1>
                  <h2 className="text-white">Years</h2>
                  <h5 className="text-white mb-0">Career Guidance</h5>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-lg-6"
            data-aos="fade-up"
            data-aos-delay="500"
          >
            <div className="h-100">
              <h1 className="display-6 fw-bold mb-5">
                Your Trusted Partner in Career Guidance and Success
              </h1>
              <p className="fs-5 text-primary mb-4" style={{textAlign:'justify'}}>
                MyCareerGems is an educational counseling platform that helps students professionally across all
                verticals. We assist students and professionals in developing a broad vision for their education.
              </p>
              <div className="row g-4 mb-4">
                <div className="col-sm-6">
                  <div className="d-flex align-items-center">
                    <img
                      className="flex-shrink-0 me-3"
                      src={icon1}
                      alt="Expert Advice"
                    />
                    <h5 className="mb-0">Expert Career Advice</h5>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="d-flex align-items-center">
                    <img
                      className="flex-shrink-0 me-3"
                      src={icon2}
                      alt="Industry Insights"
                    />
                    <h5 className="mb-0">Industry Insights</h5>
                  </div>
                </div>
              </div>
              <p className="mb-4" style={{textAlign:'justify'}}>
                Understanding the intricacies of higher studies, career progression or professional development
                systems is not easy, that is why sought out experts help based on their experiences. Regardless of
                your educational qualification, as long as you are looking for guidance in furthering your career,
                MyCareerGems will definitely help you in achieving your aspirations.
              </p>
              <div className="border-top mt-4 pt-4">
                <div className="d-flex align-items-center">
                  <img
                    className="flex-shrink-0 rounded-circle me-3"
                    src={ceo}
                    width={50}
                    height={50}
                    alt="CEO"
                  />
                  <h5 className="mb-0">Call Us: +91 74492 06853</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SecondaryAbout;
